declare const sgSettings: any;

export default function getGameTitle(fallback?: string): string {
  const useGISName = (
    sgSettings.config &&
    sgSettings.config.crossword &&
    sgSettings.config.crossword.customisation &&
    sgSettings.config.crossword.customisation.useGISNameOnWelcomeScreen
  );

  return (useGISName === true ? document.title : fallback) || "";
}
